<template>
  <div class="flex flex-col">
    <label
      class="text-text-primary text-sm font-medium dark:text-dark-secondary"
      :class="labelClass"
    >
      Comentarios
      <span v-if="required" class="text-text-error">*</span>
    </label>
    <Textarea 
      class="focus:border-border-focus!"
      :class="labelClass"
      v-model="model"
      :rows="rows" 
      :cols="cols"
      :auto-resize="autoResize"
      placeholder="Escriba su comentario"
      :disabled="disabled"
    />
  </div>
</template>

<script setup>
const model = defineModel();
const props = defineProps({
  rows: { type: Number, default: 5 },
  cols: { type: Number, default: 33 },
  disabled: { type: Boolean, default: false },
  autoResize: { type: Boolean, default: true },
  placeholder: { type: String, default: '' },
  labelClass: { type: String, default: '' }
})
</script>